const PROFILE_CACHE_VERSION = 'v1';
const PROFILE_CACHE_PREFIX = `lais:profile-cache:${PROFILE_CACHE_VERSION}`;
export const PROFILE_CACHE_TTL_MS = 12 * 60 * 60 * 1000;

const safeStorage = storage => {
  if (storage) return storage;
  if (typeof window === 'undefined') return null;
  return window.localStorage || null;
};

const normalizeIdentity = identity =>
  String(identity || '')
    .trim()
    .toLowerCase();

export const identityFromUser = user =>
  normalizeIdentity(user?.email || user?.uid || user?.id);

export const identityFromAuthData = authData =>
  normalizeIdentity(authData?.uid || authData?.email || authData?.id);

const cacheKey = identity => `${PROFILE_CACHE_PREFIX}:${identity}`;

export const cacheUserProfile = (
  user,
  { now = Date.now(), storage } = {}
) => {
  const targetStorage = safeStorage(storage);
  const identity = identityFromUser(user);
  if (!targetStorage || !identity || !user) return false;

  targetStorage.setItem(
    cacheKey(identity),
    JSON.stringify({
      identity,
      cachedAt: now,
      expiresAt: now + PROFILE_CACHE_TTL_MS,
      user,
    })
  );
  return true;
};

export const readCachedUserProfile = (
  { identity, now = Date.now(), storage } = {}
) => {
  const targetStorage = safeStorage(storage);
  const normalizedIdentity = normalizeIdentity(identity);
  if (!targetStorage || !normalizedIdentity) return null;

  try {
    const payload = JSON.parse(
      targetStorage.getItem(cacheKey(normalizedIdentity)) || 'null'
    );

    if (!payload?.user || payload.identity !== normalizedIdentity) return null;
    if (payload.expiresAt <= now) return null;

    return payload.user;
  } catch {
    return null;
  }
};
